import React from 'react';
import ResourceSubTile from "./ResourceSubTile";

const DownLoadMyRecordTile = ({ isShowAllUsers, disabled
}) => {  

    let Msg = 'Submit requests to recieve a formal copy of your health records.';      
    let urlTo = "/familyselection/medicalrecord"; 
    return (
        <ResourceSubTile           
            heading="Download My Record"
            description={Msg}
            url={urlTo}
            disabled={disabled}
        />
    );
}

export default DownLoadMyRecordTile;
